import Landing_sec1 from "../components/landing_sec1";
import Landing_sec2 from "../components/landing_sec2";
import Landing_sec3 from "../components/landing_sec3";
import Landing_sec4 from "../components/landing_sec4";
import Landing_sec5 from "../components/landing_sec5";

const Landing = () => (
  <>
    <Landing_sec1/>
    <Landing_sec2/>
    <Landing_sec3/>
    <Landing_sec4/>
    <Landing_sec5/>
  </>
);

export default Landing;